import styled from 'styled-components';
import { StyledFunction } from 'styled-components';
import { Link } from 'react-router';
import * as React from 'react';

export const Title: any = styled.h1`
  margin: 0;
  padding: 0;
  margin: 20px 0;
  font-size: 2rem;
  font-weight: bold;

  ${({ theme }) => theme.media.s`
  font-size: 1.5rem;
 `};
`;

export const TitleCenter: any = styled(Title)`
  text-align: center;
`;

export const TextCenter: any = styled.div`
  text-align: center;
`;

export const TextRight: any = styled.div`
  text-align: right;
`;

export const TextP: any = styled.p`
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0;
`;

export const TextSpan: any = styled.span`
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0;
`;

export interface TextLinkProps {
  color?: string;
  theme?: any;
  underline?: boolean;
}
const textLinkInterface: any = styled.a;

export const TextLink = textLinkInterface`
  color: ${({ color, theme }) => (color ? color : theme.btnPrimary)};
  text-decoration: ${({ underline }) => (underline ? 'underline' : 'none')};
  &:hover {
    text-decoration: ${({ underline }) => (underline ? 'none' : 'none')};
  }
`;

export const StyledLink = styled(Link)`
  color: ${({ color, theme }: any) =>
    color === 'black' ? theme.black : theme.btnPrimary};
`;
